export class ScreenUtils {
  private static readonly MOBILE_RESOLUTION = 768;
  private static readonly LANDSCAPE_RESOLUTION = 1024;

  static get screenWidth(): number {
    return (
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    );
  }

  static isMobileResolution(): boolean {
    return ScreenUtils.screenWidth <= ScreenUtils.MOBILE_RESOLUTION;
  }

  static isDesktopResolution(): boolean {
    return ScreenUtils.screenWidth > ScreenUtils.MOBILE_RESOLUTION;
  }

  static isLandScapeResolution(): boolean {
    return (
      ScreenUtils.screenWidth < ScreenUtils.LANDSCAPE_RESOLUTION &&
      ScreenUtils.screenWidth >= ScreenUtils.MOBILE_RESOLUTION
    );
  }

  static isLargeDesktopResolution(): boolean {
    return ScreenUtils.screenWidth >= ScreenUtils.LANDSCAPE_RESOLUTION;
  }

  static hasHoverScreen(): boolean {
    return window.matchMedia('(hover: hover)').matches;
  }

  static isTouchScreen(): boolean {
    return !window.matchMedia('(pointer: fine)').matches;
  }
}
